import React from 'react';

export default function NewYearsHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="30.98,36.4 9.15,36.4 5.93,8.85 27.76,8.85" fill="#F1E3C3" />
      <polygon points="30.98,36.4 9.15,36.4 5.93,8.85 27.76,8.85" fill="#F1E3C3" />
      <polygon points="27.8,18.76 12.2,18.76 12.2,3.17 27.8,3.17" fill="#F1E3C3" />
      <polygon points="22.34,19.93 17.66,17.6 17.66,2.0 22.34,4.34" fill="#DDBC70" opacity="0.95" />
      <polygon points="25.15,19.85 14.85,17.68 14.85,2.09 25.15,4.25" fill="#DDBC70" opacity="0.95" />
      <polygon points="27.17,19.59 12.83,17.94 12.83,2.34 27.17,4.0" fill="#F1E3C3" />
      <polygon points="28.1,19.21 11.9,18.32 11.9,2.72 28.1,3.62" fill="#F1E3C3" />
      <polygon points="26.31,18.32 13.69,19.21 13.69,3.62 26.31,2.72" fill="#F1E3C3" />
      <polygon points="23.86,17.94 16.14,19.59 16.14,4.0 23.86,2.34" fill="#F1E3C3" />
      <polygon points="20.82,17.68 19.18,19.85 19.18,4.25 20.82,2.09" fill="#DDBC70" opacity="0.95" />
      <polygon points="23.06,38.0 16.51,34.73 27.25,8.79 33.8,12.07" fill="#DDBC70" opacity="0.95" />
      <polygon points="23.49,38.0 16.94,34.73 6.2,8.79 12.75,12.07" fill="#DDBC70" opacity="0.95" />
      <polygon points="23.49,38.0 16.94,34.73 6.2,8.79 12.75,12.07" fill="#DDBC70" opacity="0.95" />
      <polygon points="23.06,38.0 16.51,34.73 27.25,8.79 33.8,12.07" fill="#DDBC70" opacity="0.95" />
      <polygon points="30.85,36.33 9.02,36.33 12.24,12.01 34.07,12.01" fill="#F1E3C3" />
      <polygon points="30.85,36.33 9.02,36.33 12.24,12.01 34.07,12.01" fill="#F1E3C3" />
    </svg>
  );
}
